<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
body.swal2-shown {
  padding-right: 0 !important;
}
.swal-confirm-button,
.swal-cancel-button {
  color: white !important;
}
.swal2-confirm {
  background-color: #3085d6 !important;
  color: white !important;
  border: none;
}
.swal2-confirm:hover {
  background-color: #2563eb !important;
}
</style>
